import { useCallback, useEffect, useState } from "react";
import { HaulRoute } from "../models/HaulRoute";
import PlotAPI from "../plotAPI";

interface useHaulRoutesProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useHaulRoutes = ({ projects, projectInfo }: useHaulRoutesProps) => {
    const [haulRoutesByProject, setHaulRoutesByProject] = useState<
        { unique_token: string; haulRoutes: HaulRoute[] }[]
    >([]);

    const refreshHaulRoutesByProject = useCallback(() => {
        return Promise.all(
            projects.map((project) =>
                PlotAPI.getProjectHaulRoutes(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((haulRoutes) => {
                    return {
                        unique_token: project.unique_token,
                        haulRoutes,
                    };
                })
            )
        ).then((haulRoutes) => {
            setHaulRoutesByProject(haulRoutes);
        });
    }, [projects]);

    useEffect(() => {
        refreshHaulRoutesByProject();
    }, [projects, refreshHaulRoutesByProject]);

    const haulRoutesForProject = (projectId: string | number): HaulRoute[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return haulRoutesByProject.find((project) => project.unique_token === projectToken)?.haulRoutes || [];
    };

    return {
        haulRoutesByProject,
        haulRoutesForProject,
        refreshHaulRoutesByProject,
    };
};

export default useHaulRoutes;
